
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/lighting",
      function () {
        return require("private-next-pages/solutions/lighting.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/lighting"])
      });
    }
  